module.exports = __webpack_public_path__ + "img/storage4.4e62d11a.png";